/**
 * Main SEO Structured Data for Organization and Website
 * Provides comprehensive Schema.org markup for better Google understanding
 */

export const SEOStructuredData = () => {
  const organizationData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Scholz Interim",
    "legalName": "Scholz Interim GmbH",
    "url": "https://scholz-interim.de",
    "logo": "https://scholz-interim.de/logo-icon.png",
    "description": "Headhunter und Personalvermittler für Führungskräfte in Hotellerie, Gastronomie und Tourismus. Seit 2002 über 900 erfolgreiche Vermittlungen.",
    "foundingDate": "2002",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+49-40-123456",
      "contactType": "customer service",
      "areaServed": "DE",
      "availableLanguage": ["German", "English"]
    },
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "DE",
      "addressLocality": "Deutschland"
    },
    "sameAs": [
      "https://www.linkedin.com/company/scholz-interim",
      "https://www.xing.com/companies/scholzinterim"
    ],
    "knowsAbout": [
      "Headhunting",
      "Executive Search",
      "Personalvermittlung",
      "Hotellerie",
      "Gastronomie",
      "Tourismus",
      "Interim Management",
      "Verpachtung"
    ],
    "areaServed": {
      "@type": "Country",
      "name": "Deutschland"
    }
  };

  const websiteData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Scholz Interim",
    "url": "https://scholz-interim.de",
    "description": "Executive Search für Hotellerie & Gastronomie",
    "publisher": {
      "@type": "Organization",
      "name": "Scholz Interim"
    },
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://scholz-interim.de/stellenangebote?search={search_term_string}"
      },
      "query-input": "required name=search_term_string"
    },
    "inLanguage": "de-DE"
  };

  const professionalServiceData = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "Scholz Interim",
    "image": "https://scholz-interim.de/logo-icon.png",
    "url": "https://scholz-interim.de",
    "description": "Headhunter und Personalvermittler für Führungskräfte in Hotellerie, Gastronomie und Tourismus",
    "priceRange": "$$",
    "areaServed": {
      "@type": "Country",
      "name": "Deutschland"
    },
    "serviceType": [
      "Executive Search",
      "Headhunting",
      "Personalvermittlung",
      "Interim Management",
      "Verpachtung"
    ]
  };

  return (
    <>
      <script 
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationData) }}
      />
      <script 
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteData) }}
      />
      <script 
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(professionalServiceData) }}
      />
    </>
  );
};
